import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcDone32Icon } from '@gem/icons';

import { MediaPreview } from 'APP/components/MediaPreview/MediaPreview';
import { MEDIA_PREVIEW_MAX_SIZE } from 'APP/constants/messages';
import { useAlbumPayloadItemPresenter } from 'APP/main/ChatView/Messages/Message/Payload/Album/AlbumPayloadItem/AlbumPayloadItem.presenter';
import { UploaderState } from 'APP/main/ChatView/components/UploaderState/UploaderState';
import { ImagePayload } from 'STORE/Messages/Message/Payload/ImagePayload/ImagePayload';
import { VideoPayload } from 'STORE/Messages/Message/Payload/VideoPayload/VideoPayload';

import styles from './AlbumPayloadItem.styles.m.css';

export interface IAlbumPayloadItemProps {
  id: string;
  payloadId: string;
  groupId: string;
  messageId: string;
  payload: ImagePayload | VideoPayload;
  isLoading: boolean;
  isPreview: boolean;
  isView: boolean;
  isFromMe: boolean;
  openGallery(mediaId: string): void;
  hasError: boolean;
}

export const AlbumPayloadItem: FC<IAlbumPayloadItemProps> = observer(
  ({
    id,
    payloadId,
    hasError,
    groupId,
    messageId,
    payload,
    isLoading,
    isPreview,
    isView,
    isFromMe,
    openGallery,
  }) => {
    const presenter = useAlbumPayloadItemPresenter({ id, payload, openGallery, isLoading });
    if (!payload?.previewUrl) {
      return null;
    }

    const containerClassName = classNames(styles.container, {
      [styles.myItem]: isFromMe,
    });

    return (
      <div className={containerClassName}>
        <MediaPreview
          className={styles.preview}
          payload={payload}
          maxWidth={MEDIA_PREVIEW_MAX_SIZE.width}
          maxHeight={MEDIA_PREVIEW_MAX_SIZE.height}
          isPreview={isPreview}
          isView={isView}
          onClick={presenter.onClick}
          payloadId={payloadId}
          groupId={groupId}
          messageId={messageId}
          imageClassName={styles.mediaImage}
          isPlayIcon={presenter.isPlayIcon || undefined}
        />

        <UploaderState
          className={styles.uploader}
          uploadFileData={{
            uploadProgress: payload.uploadProgress,
            cancelUpload: presenter.cancelUpload,
            hasError,
          }}
        >
          {isLoading && <IcDone32Icon className={styles.icon} />}
        </UploaderState>
      </div>
    );
  }
);
